import React from "react";
import styles from "./styles.module.scss";

const TestSyllabusChapterRow = ({ chapterObject }) => {
  return (
    <div className={styles.test_syallabus_chapter_container}>
      {/* Col A — Chapter title */}
      <div
        className={styles["chapter-node"]}
        style={{ fontWeight: 600, fontSize: "16px", color: "#0F0F0F" }}
      >
        {chapterObject?.title}
      </div>

      {/* Col B — All topics */}
      <div>
        {chapterObject?.children?.map((topicObject) => {
          const subtopics = topicObject?.children ?? [];

          const rowCount = Math.max(subtopics.length, 1);

          return (
            <div
              key={topicObject?.key ?? topicObject?.title}
              className={styles.test_syallabus_topic_container}
              style={{
                // Override grid-template-rows to exactly rowCount rows.
                // This ensures row-gap applies between every sub-topic row.
                gridTemplateRows: `repeat(${rowCount}, max-content)`,
              }}
            >
              {/*
                Topic title — spans ALL sub-topic rows so it visually
                "covers" the entire topic block without repeating.
              */}
              <div
                className={styles["topic-node"]}
                style={{
                  gridColumn: 1,
                  gridRow: `1 / span ${rowCount}`,
                }}
              >
                {topicObject?.title}
              </div>

              {subtopics.length > 0 ? (
                subtopics.map((subtopicObject, rowIdx) => {
                  const subSubTopics = subtopicObject?.children ?? [];

                  return (
                    <React.Fragment
                      key={subtopicObject?.key ?? subtopicObject?.title}
                    >
                      {/* Col 2 — Sub-topic title */}
                      <div
                        style={{
                          gridColumn: 2,
                          gridRow: rowIdx + 1,
                        }}
                      >
                        <ul style={{ marginBottom: 0, paddingLeft: "1rem" }}>
                          <li>{subtopicObject?.title}</li>
                        </ul>
                      </div>

                      {/* Col 3 — Sub-sub-topic list (empty if none) */}
                      <div
                        style={{
                          gridColumn: 3,
                          gridRow: rowIdx + 1,
                        }}
                      >
                        {subSubTopics.length > 0 && (
                          <ul style={{ marginBottom: 0, paddingLeft: "1rem" }}>
                            {subSubTopics.map((subSubtopicObject) => (
                              <li
                                key={
                                  subSubtopicObject?.key ??
                                  subSubtopicObject?.title
                                }
                              >
                                {subSubtopicObject?.title}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </React.Fragment>
                  );
                })
              ) : (
                // Topic has no sub-topics — fill cols 2 & 3 with empty divs
                <React.Fragment>
                  <div style={{ gridColumn: 2, gridRow: 1 }} />
                  <div style={{ gridColumn: 3, gridRow: 1 }} />
                </React.Fragment>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TestSyllabusChapterRow;
